import { ROUTE_PAGE_DASHBOARD } from '@components/Router/constants'
import { migrationAuthSelector } from '@store/migrationSelectors/authSelectors'
import type { Workspace } from '@store/reducers/dashboard/types'
import { saveLastWorkspaceId } from '@store/reducers/dashboard/utils'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useMatch } from 'react-router-dom'

export const useSaveLastWorkspace = (current: Workspace | null) => {
  const userId = useSelector(migrationAuthSelector.getUserId)
  const dashboardMatch = useMatch(ROUTE_PAGE_DASHBOARD)
  const urlWorkspaceId = dashboardMatch?.params.workspaceId || null

  useEffect(() => {
    if (!urlWorkspaceId || !userId || !current || current.expired) {
      return
    }

    saveLastWorkspaceId(userId, current.id)
  }, [urlWorkspaceId, userId, current])
}
